import { useSelector } from 'react-redux';
import { Controller } from 'react-hook-form';
import { useMemo } from 'react';
import { SliderProps } from '@mui/material';

import PrettoSlider, { themeColors } from '../../PrettoSlider/PrettoSlider';
import { RootState } from '../../../store/rootReducer';
import { UseControllerProps } from './forms-types';

type sliderProps = SliderProps & {
  'data-cy'?: string; // 👈 Cypress selector
};

interface SliderControllerProps {
  sliderProps?: sliderProps;
  controllerProps: UseControllerProps;
}

const ControlledSlider: React.FC<SliderControllerProps> = ({ sliderProps, controllerProps }) => {
  const provider = useSelector((state: RootState) => state.general.provider);

  const themeCol = useMemo(() => {
    if (provider) {
      return themeColors[provider as keyof typeof themeColors];
    }
    return themeColors['00000016'];
  }, [provider]);

  return (
    <Controller
      {...controllerProps}
      render={({ field }) => (
        <PrettoSlider
          style={themeCol}
          {...field}
          onChange={(_: any, newValue: any) => {
            field.onChange(newValue);
          }}
          ref={field.ref}
          {...sliderProps}
        />
      )}
      rules={{
        ...controllerProps.rules,
      }}
    />
  );
};

export default ControlledSlider;
